import React from 'react';
import { Tabs, Tab, Paper } from '@material-ui/core';
const QmeTrackerTabs = ({ tabIndex, count, handleTabChange }) => {
  return (
    <Paper className='project-tabs'>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
      >
        <Tab label={`All (${count.total || 0})`} value="all" />
        <Tab label={`Open (${count.open || 0})`} value="1" />
        <Tab label={`WIP (${count.wip || 0})`} value="2" />
        <Tab label={`On-Hold (${count.on_hold || 0})`} value="3" />
        <Tab label={`Closed (${count.closed || 0})`} value="4" />
      </Tabs>
    </Paper>
  )
}
export default QmeTrackerTabs;
